"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TermLengthSliderStyle = void 0;
var _react = require("@linaria/react");
var _intents = _interopRequireDefault(require("@ux/intents"));
var _core = require("@linaria/core");
"t193czeu";
const intents = new _intents.default();
const TermLengthSliderStyle = exports.TermLengthSliderStyle = /*#__PURE__*/(0, _react.styled)("div")({
  name: "TermLengthSliderStyle",
  class: "t9wjwpq"
});